import commonService from './common-service';
import facilityService from './facility-service';

class ApprovalQueService {
  async getFacilities() {
    return await facilityService.getFacilities();
  }

  async getApprovalRequestsByFacility(facId) {
    try {
      const response = await commonService.getFromServer('FLStocks/Approval/' + facId, {});
      return Array.isArray(response) ? response : [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async approveRequest(ids, quantitiesData) {
    try {
      const payload = { ids: ids, quantities: quantitiesData };
      const response = await commonService.postToServer('FLStocks/Approve', payload);
      if (response !== undefined && response !== null) return response;
      throw new Error('Error approving request(s).');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async denyRequest(ids, quantitiesData) {
    try {
      const payload = { ids: ids, quantities: quantitiesData };
      const response = await commonService.postToServer('FLStocks/Deny', payload);
      if (response !== undefined && response !== null) return response;
      throw new Error('Error denying request(s).');
    } catch (e) {
      throw new Error(e.message);
    }
  }
}
export default new ApprovalQueService();

